export abstract class BaseBannerLogic {

}